import React, { useMemo } from "react"

/**
 * @typedef {Object} DailyTimestampProps
 * @property {import("../MessageItem").Message} message
 * @property {import("@material-ui/styles").ClassNameMap} classes
 * @property {Message | null} [previousMessage]
 * @property {(date: string) => boolean} isSameDay
 * @property {(date: string) => string} dataDescricao
 * @property {(date: string) => Date} parseISO
 */

const DailyTimestamp = React.memo(
  /**
   * @param {DailyTimestampProps} props
   */
  ({ message, previousMessage, isSameDay, parseISO, dataDescricao, classes }) => {
    const isFirstMessageOfDay = useMemo(() => {
      if (!message?.createdAt) return false
      if (!previousMessage) return true

      try {
        return !isSameDay(parseISO(message.createdAt), parseISO(previousMessage.createdAt))
      } catch {
        return false
      }
    }, [message?.createdAt, previousMessage, isSameDay, parseISO])

    if (!isFirstMessageOfDay) return null

    return (
      <span className={classes.dailyTimestamp}>
        <div className={classes.dailyTimestampText}>{dataDescricao(message.createdAt)}</div>
      </span>
    )
  },
)

DailyTimestamp.displayName = "DailyTimestamp"
export default DailyTimestamp
